import apiClient from '../axios';

// Interfaces
export interface ApiResponse<T> {
  responseValue: T;
  statusCode: number;
  message: string;
}

export interface RegionSet {
  id: number;
  name: string;
  language: string;
}

export interface Region {
  id: number;
  regionSets: RegionSet[];
}

export interface GetAllRegionsResponse extends Array<Region> {}

export const regionService = {
  // Get all regions
  async getAllRegions(): Promise<ApiResponse<GetAllRegionsResponse>> {
    const response = await apiClient.get('/Regions/web/get-all');
    
    return response.data;
  }
};

export default regionService;
